import { render, staticRenderFns } from "./PrintTag.vue?vue&type=template&id=76b1a19c&scoped=true"
import script from "./PrintTag.vue?vue&type=script&lang=js"
export * from "./PrintTag.vue?vue&type=script&lang=js"
import style0 from "./PrintTag.vue?vue&type=style&index=0&id=76b1a19c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.103.0__lodash@4.17.21_vue-template-compiler@2.7.16_webpack@5.103.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b1a19c",
  null
  
)

export default component.exports